var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeedUnitIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 24 24"
    },
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0d6efd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,3c-4.6,0-8.4,3.4-8.9,7.9l2,0.2C5.5,7.7,8.5,5,12,5c3.5,0,6.5,2.7,6.9,6.2l2-0.2C20.4,6.4,16.6,3,12,3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,14C12,14,12,14,12,14L9.9,8.6L8.1,9.4l2,5.4C9.4,15.3,9,16.1,9,17c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3   C15,15.3,13.7,14,12,14z M13,18h-2v-2h2V18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0z M12,22C6.5,22,2,17.5,2,12C2,6.5,6.5,2,12,2   c5.5,0,10,4.5,10,10C22,17.5,17.5,22,12,22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedUnitIcon);
export default __webpack_public_path__ + "static/media/speedUnitIcon.635b659507f27558f3268e423b7a94e0.svg";
export { ForwardRef as ReactComponent };